<template>
  <div class="card m-3 shadow">
    <b-tabs small card>
      <b-tab active class="p-2">
        <template #title>
          <b-icon icon="calendar-date" variant="primary"></b-icon>
          <span class="ms-2">Filtrar por fecha de creación</span>
        </template>
        <MeetingDate></MeetingDate>
      </b-tab>

      <b-tab class="p-2">
        <template #title>
          <b-icon icon="people" variant="primary"></b-icon>
          <span class="ms-2">Filtrar por rol del organizador</span>
        </template>
        <MeetingRole />
      </b-tab>
    </b-tabs>

  </div>
</template>
<script>
import MeetingDate from '@/components/Meeting/MeetingFilter/Meeting-date.vue'
import MeetingRole from '@/components/Meeting/MeetingFilter/Meeting-role.vue'

export default {
  name: 'MeetingFilter',

  components: {
    MeetingDate,
    MeetingRole,
  }

}
</script>
